// src/components/plan/PlanDetailsTabs.js
import React, { useState } from 'react'
import CoverageBreakdownTab from './CoverageBreakdownTab'
import WaitingPeriodsTab from './WaitingPeriodsTab'
import PlanFlagsTab from './PlanFlagsTab'
import DisclaimersTab from './DisclaimersTab'

const tabs = [
  { label: '🦷 Coverage Breakdown', key: 'coverage' },
  { label: '⏳ Waiting Periods', key: 'waiting' },
  { label: '🚩 Plan Flags', key: 'flags' },
  { label: '⚠️ Disclaimers', key: 'disclaimers' },
]

function PlanDetailsTabs({ plan }) {
  const [activeTab, setActiveTab] = useState('coverage')

  const renderTabContent = () => {
    switch (activeTab) {
      case 'coverage':
        return <CoverageBreakdownTab plan={plan} />
      case 'waiting':
        return <WaitingPeriodsTab plan={plan} />
      case 'flags':
        return <PlanFlagsTab plan={plan} />
      case 'disclaimers':
        return <DisclaimersTab plan={plan} />
      default:
        return null
    }
  }

  return (
    <div style={{ marginTop: '2rem' }}>
      {/* Tab Buttons */}
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '0.5rem 1rem',
              fontSize: '0.85rem',
              fontWeight: 600,
              borderRadius: '6px',
              border: activeTab === tab.key ? '2px solid #0f172a' : '1px solid #cbd5e1',
              backgroundColor: activeTab === tab.key ? '#f1f5f9' : '#fff',
              cursor: 'pointer',
              color: '#0f172a',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div style={{ marginTop: '1rem' }}>{renderTabContent()}</div>
    </div>
  )
}

export default PlanDetailsTabs
